export default "__VITE_ASSET__66e8a087__"